import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69b6c844"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = {
  id: "mainMenu",
  style: {"height":"42px"}
}
const _hoisted_3 = { class: "pull-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-miezzback" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "btn-link btn-active",
  style: {"cursor":"default"}
}, "报关资料", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "装箱单/发票/合同信息", -1))
const _hoisted_7 = { style: {"float":"right"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "报关单", -1))
const _hoisted_20 = { style: {"float":"right"} }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { style: {"text-align":"center","margin-top":"-25px","width":"100% !important"} }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","margin":"0px","padding":"0px"} }, " 预录入编号: ", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"200px","margin":"0px auto"} }, " 海关编号: ", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "table"
}
const _hoisted_29 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_34 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_36 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_40 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_41 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_43 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_44 = { class: "cell" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_46 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_47 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_52 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_54 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_58 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_59 = {
  key: 0,
  class: "cell",
  colspan: "3"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_61 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_62 = {
  key: 1,
  class: "cell",
  colspan: "2"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_64 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_65 = {
  key: 2,
  class: "cell"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_67 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_68 = {
  class: "cell",
  style: {"min-width":"380px !important"}
}
const _hoisted_69 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_70 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_72 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_76 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_77 = { key: 0 }
const _hoisted_78 = {
  key: 0,
  class: "cell",
  colspan: "3"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_80 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_81 = {
  key: 1,
  class: "cell",
  colspan: "2"
}
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_83 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_84 = {
  key: 2,
  class: "cell"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_86 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_87 = {
  class: "cell",
  style: {"min-width":"300px !important"}
}
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_89 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_90 = {
  class: "cell",
  colspan: "2",
  style: {"max-width":"200px !important"}
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_92 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_93 = { key: 0 }
const _hoisted_94 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_95 = { key: 0 }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_97 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_98 = { key: 0 }
const _hoisted_99 = { key: 1 }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_101 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = {
  class: "cell",
  colspan: "2"
}
const _hoisted_104 = { key: 0 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_106 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_107 = { key: 1 }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_109 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_110 = { key: 0 }
const _hoisted_111 = { class: "cell" }
const _hoisted_112 = { key: 0 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_114 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_117 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_118 = {
  class: "cell",
  style: {"min-width":"300px !important"}
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_120 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_121 = { style: {"float":"left","width":"68%"} }
const _hoisted_122 = { style: {"float":"right","width":"30%"} }
const _hoisted_123 = {
  class: "cell",
  style: {"min-width":"120px !important"}
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_125 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_126 = {
  class: "cell",
  style: {"min-width":"120px !important"}
}
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_128 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_129 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_131 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_132 = {
  class: "cell",
  style: {}
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_134 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_138 = { style: {"float":"right"} }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_140 = {
  href: "javascript:;",
  tabindex: "-1",
  style: {"color":"#fe995b","text-decoration":"none","cursor":"text"}
}
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_143 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_145 = { style: {"float":"right"} }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_147 = {
  href: "javascript:;",
  tabindex: "-1",
  style: {"color":"#fe995b","text-decoration":"none","cursor":"text"}
}
const _hoisted_148 = { key: 0 }
const _hoisted_149 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_150 = {
  class: "cell",
  style: {"min-width":"120px  !important"}
}
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f66c6c"} }, " ", -1))
const _hoisted_152 = { style: {"float":"right"} }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "币制 ", -1))
const _hoisted_154 = {
  href: "javascript:;",
  tabindex: "-1",
  style: {"color":"#fe995b","text-decoration":"none","cursor":"text"}
}
const _hoisted_155 = { key: 0 }
const _hoisted_156 = { style: {"margin-top":"16px","height":"43px"} }
const _hoisted_157 = {
  class: "cell",
  colspan: "8",
  style: {"padding-bottom":"20px"}
}
const _hoisted_158 = { style: {"margin-top":"10px"} }
const _hoisted_159 = {
  class: "cell",
  colspan: "8",
  style: {"padding-top":"10px"}
}
const _hoisted_160 = ["innerHTML"]
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_162 = {
  class: "cell",
  colspan: "8"
}
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"100%","height":"35px"} }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","font-size":"14px","font-weight":"900","line-height":"40px"} }, "产品信息")
], -1))
const _hoisted_164 = {
  key: 0,
  style: {"width":"100% !important"}
}
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  cellpadding: "0",
  cellspacing: "0",
  style: {"clear":"both","width":"100% !important"}
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"4%"}
    }, "项号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"9%"}
    }, "备案序号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"7%"}
    }, "商品编号"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"15%"}
    }, "商品名称"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"10%"}
    }, "数量及单位"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"8%"}
    }, "单价/总价/币制"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "原产国（地区）"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "最终目的国（地区）"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"12%"}
    }, "境内货源地"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"6%"}
    }, "征免"),
    /*#__PURE__*/_createElementVNode("td", {
      class: "header",
      style: {"width":"5%"}
    }, "操作")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      colspan: "12",
      class: "data",
      style: {"height":"40px","line-height":"40px","text-align":"center"}
    }, " 暂无数据 ")
  ])
], -1))
const _hoisted_166 = [
  _hoisted_165
]
const _hoisted_167 = { key: 1 }
const _hoisted_168 = {
  cellpadding: "0",
  cellspacing: "0",
  style: {"clear":"both","width":"100%"}
}
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"4%"}
  }, "项号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"9%"}
  }, "备案序号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"7%"}
  }, "商品编号"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"15%"}
  }, "商品名称"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"10%"}
  }, "数量及单位"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"8%"}
  }, "单价/总价/币制"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "原产国（地区）"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "最终目的国（地区）"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"12%"}
  }, "境内货源地"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"6%"}
  }, "征免"),
  /*#__PURE__*/_createElementVNode("td", {
    class: "header",
    style: {"width":"5%"}
  }, "操作")
], -1))
const _hoisted_170 = {
  class: "data",
  colspan: "20"
}
const _hoisted_171 = {
  class: "data",
  style: {"width":"100% !important","height":"100% !important"}
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_173 = ["innerHTML"]
const _hoisted_174 = {
  key: 0,
  style: {"margin":"0px","padding":"0px"}
}
const _hoisted_175 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_176 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_177 = { style: {"margin":"0px","padding":"0px"} }
const _hoisted_178 = { style: {"float":"left","width":"5%"} }
const _hoisted_179 = ["onClick"]
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"5px"} }, null, -1))
const _hoisted_181 = ["innerHTML"]
const _hoisted_182 = { style: {"float":"left"} }
const _hoisted_183 = { style: {"float":"right"} }
const _hoisted_184 = { style: {"clear":"both","padding-bottom":"40px"} }
const _hoisted_185 = {
  cellpadding: "0",
  cellspacing: "0",
  class: "tbAnnex",
  style: {"width":"40%"}
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { style: {"font-size":"14px","height":"24px"} }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document" }),
  /*#__PURE__*/_createTextVNode(" 报关资料 ")
], -1))
const _hoisted_187 = { key: 0 }
const _hoisted_188 = { style: {"font-size":"14px","height":"24px"} }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-document" }, null, -1))
const _hoisted_190 = { style: {"font-size":"12px","cursor":"pointer","color":"#409eff"} }
const _hoisted_191 = ["href"]
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, "选择包装种类", -1))
const _hoisted_193 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_194 = {
  key: 0,
  style: {"position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #ccc"}
}
const _hoisted_195 = {
  key: 1,
  style: {"text-indent":"1px","position":"relative","border-radius":"2px","width":"14px","height":"14px","border":"1px solid #409eff","line-height":"14px","background-color":"#409eff","color":"#ffffff","font-size":"10px"}
}
const _hoisted_196 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Document = _resolveComponent("Document")!
  const _component_Paperclip = _resolveComponent("Paperclip")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_Check = _resolveComponent("Check")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_customs_product_detail = _resolveComponent("miezz-customs-product-detail")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "btn-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleBack()))
          }, [
            _hoisted_4,
            _createTextVNode(" 返回 ")
          ]),
          _hoisted_5
        ])
      ]),
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isContact = !_ctx.isContact))
          }, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              (_ctx.isContact==false)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDownBold)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUpBold)
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isContact==false)
            ? (_openBlock(), _createBlock(_component_miezz_form, {
                key: 0,
                ref: "ruleForm",
                modelValue: _ctx.detail,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.detail) = $event)),
                fix: true
              }, {
                "form-item": _withCtx(({ item }) => [
                  (item.Prop == 'OrderNumber')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.OrderNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'OrderDate')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.OrderDateString), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'InvoiceNumber')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.InvoiceNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'InvoiceDate')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 3,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.InvoiceDateString), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'FirstConsignorId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 4,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.Type == 10 && _ctx.detail.Data.FirstConsignor!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.detail.Data.FirstConsignor.NameZh), 1))
                            : _createCommentVNode("", true),
                          (_ctx.detail.Data.Type == 20 && _ctx.detail.Data.FirstConsignor!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.detail.Data.FirstConsignor.NameEn), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'FirstConsigneeId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 5,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.Type == 10 && _ctx.detail.Data.FirstConsignee!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.detail.Data.FirstConsignee.NameEn), 1))
                            : _createCommentVNode("", true),
                          (_ctx.detail.Data.Type == 20 && _ctx.detail.Data.FirstConsignee!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.detail.Data.FirstConsignee.NameZh), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'SellerContent')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 6,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.detail.Data.SellerContent,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detail.Data.SellerContent) = $event)),
                            autosize: { minRows: 5, maxRows: 5 },
                            type: "textarea",
                            readonly: true,
                            placeholder: "请填写"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'BuyerContent')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 7,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.detail.Data.BuyerContent,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.detail.Data.BuyerContent) = $event)),
                            autosize: { minRows: 5, maxRows: 5 },
                            type: "textarea",
                            readonly: true,
                            onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onGetBuyer())),
                            placeholder: "请填写"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'CollectionBankId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 8,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.CollectionBank!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.detail.Data.CollectionBank.NameZh) + "/" + _toDisplayString(_ctx.detail.Data.CollectionBank.NameEn), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'PaymentBankId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 9,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.PaymentBank!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.detail.Data.PaymentBank.NameZh) + "/" + _toDisplayString(_ctx.detail.Data.PaymentBank.NameEn), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'CollectionBankContent')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 10,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.detail.Data.CollectionBankContent,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.detail.Data.CollectionBankContent) = $event)),
                            autosize: { minRows: 5, maxRows: 5 },
                            type: "textarea",
                            readonly: true,
                            placeholder: "请填写"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'PaymentBankContent')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 11,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.detail.Data.PaymentBankContent,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.detail.Data.PaymentBankContent) = $event)),
                            autosize: { minRows: 5, maxRows: 5 },
                            type: "textarea",
                            readonly: true,
                            placeholder: "请填写"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'DispatchPortId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 12,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.DispatchPort!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.detail.Data.DispatchPort.FullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'DestinationPortId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 13,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.DestinationPort!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.detail.Data.DestinationPort.FullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'ContactTransportModeId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 14,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.ContactTransportMode!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.detail.Data.ContactTransportMode.FullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'Address')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 15,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.Address), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'TradeTermsId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 16,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.TradeTerms!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.detail.Data.TradeTerms.FullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'DeliveryRequirement')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 17,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.DeliveryRequirement), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'PaymentTermsId')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 18,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          (_ctx.detail.Data.PaymentTerms!=undefined)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.detail.Data.PaymentTerms.FullName), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'PaymentTermsContent')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 19,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.PaymentTermsContent), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'CreditNumber' && _ctx.isCredit==true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 20,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.CreditNumber), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'IssuingDate' && _ctx.isCredit==true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 21,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.IssuingDateString), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'OpenCertificateDays' && _ctx.isCredit==true)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        prop: item.Prop,
                        key: _ctx.creditRandom,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.OpenCertificateDays), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true),
                  (item.Prop == 'ShippingMarks')
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 23,
                        prop: item.Prop,
                        label: item.Label
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.detail.Data.ShippingMarks), 1)
                        ]),
                        _: 2
                      }, 1032, ["prop", "label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
        header: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isCustoms = !_ctx.isCustoms))
          }, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_ctx.isCustoms==false)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDownBold)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUpBold)
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        default: _withCtx(() => [
          (_ctx.isCustoms==false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  (_ctx.type=='10')
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_23, "中华人民共和国海关出口货物报关单（最新版）"))
                    : (_ctx.type=='20')
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_24, "中华人民共和国海关进口货物报关单（最新版）"))
                      : _createCommentVNode("", true)
                ]),
                _createVNode(_component_el_row, {
                  gutter: 24,
                  style: {"height":"30px","overflow":"hidden","font-size":"14px","line-height":"30px","margin-top":"-10px"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _hoisted_25
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createTextVNode("   ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, { gutter: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_form, {
                          ref: "ruleFormCustoms",
                          modelValue: _ctx.detail,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.detail) = $event)),
                          fix: true
                        }, {
                          "form-item": _withCtx(({ item }) => [
                            (item.Prop == 'ConsignorCode')
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  "label-width": "0px"
                                }, {
                                  default: _withCtx(() => [
                                    (item.Prop == 'ConsignorCode')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                          _createElementVNode("table", _hoisted_28, [
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_29, [
                                                (_ctx.type=='10')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                      _createElementVNode("div", null, [
                                                        _createVNode(_component_el_form_item, {
                                                          label: "境内发货人",
                                                          "label-width": "85px",
                                                          prop: "ConsignorCode"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsignorCode), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_31, [
                                                        _createVNode(_component_el_form_item, {
                                                          "label-width": "0px",
                                                          label: " ",
                                                          prop: "ConsignorCompanyName",
                                                          style: {"margin-left":"-9px"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsignorCompanyName), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]))
                                                  : (_ctx.type=='20')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                                        _createElementVNode("div", null, [
                                                          _createVNode(_component_el_form_item, {
                                                            label: "境内收货人",
                                                            "label-width": "85px",
                                                            prop: "ConsigneeCode"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsigneeCode), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_33, [
                                                          _createVNode(_component_el_form_item, {
                                                            "label-width": "0px",
                                                            label: " ",
                                                            prop: "ConsigneeCompanyName",
                                                            style: {"margin-left":"-9px"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsigneeCompanyName), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_34, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_35,
                                                  _createVNode(_component_el_form_item, {
                                                    label: _ctx.type=='10'?'申报地海关':'进境关别',
                                                    "label-width": _ctx.type=='10'?'83px':'70px',
                                                    style: {"margin-top":"-34px"}
                                                  }, null, 8, ["label", "label-width"])
                                                ]),
                                                _createElementVNode("div", _hoisted_36, [
                                                  _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.Customhouse!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.detail.Data.Customhouse.FullName), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_38, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_39,
                                                  _createVNode(_component_el_form_item, {
                                                    label: _ctx.type=='10'?'出口日期':'进口日期',
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  }, null, 8, ["label"])
                                                ]),
                                                _createElementVNode("div", _hoisted_40, [
                                                  _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("   ")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_41, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_42,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "申报日期",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_43, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    style: {"margin-top":"18px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("   ")
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_44, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_45,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "备案号",
                                                    "label-width": "55px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_46, [
                                                  _createVNode(_component_el_form_item, {
                                                    prop: "RecordNumber",
                                                    "label-width": "2px"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.RecordNumber), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_47, [
                                                (_ctx.type=='10')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                                      _createElementVNode("div", null, [
                                                        _createVNode(_component_el_form_item, {
                                                          label: "境外收货人",
                                                          "label-width": "85px",
                                                          prop: "ConsigneeCode"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsigneeCode), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_49, [
                                                        _createVNode(_component_el_form_item, {
                                                          "label-width": "0px",
                                                          label: " ",
                                                          prop: "ConsigneeCompanyName",
                                                          style: {"margin-left":"-9px"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsigneeCompanyName), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]))
                                                  : (_ctx.type=='20')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                                        _createElementVNode("div", null, [
                                                          _createVNode(_component_el_form_item, {
                                                            label: "境外发货人",
                                                            "label-width": "85px"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsignorCode), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_51, [
                                                          _createVNode(_component_el_form_item, {
                                                            "label-width": "0px",
                                                            label: " ",
                                                            prop: "ConsignorCompanyName",
                                                            style: {"margin-left":"-9px"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.detail.Data.ConsignorCompanyName), 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_52, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_53,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "运输方式",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_54, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "2px",
                                                    label: "",
                                                    prop: "TransportModeId"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.TransportMode!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, _toDisplayString(_ctx.detail.Data.TransportMode.FullName), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_56, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_57,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "运输工具名称及航次号",
                                                    "label-width": "153px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_58, [
                                                  _createVNode(_component_el_form_item, { "label-width": "0px" })
                                                ])
                                              ]),
                                              (_ctx.type=='10')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_59, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_60,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "提运单号",
                                                        "label-width": "70px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_61, [
                                                      _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.BLNO), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.type=='20')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_62, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_63,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "提运单号",
                                                        "label-width": "70px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_64, [
                                                      _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.BLNO), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.type=='20')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_65, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_66,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "货物存放地点",
                                                        "label-width": "96px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.detail.Data.GoodsAddress), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_68, [
                                                _createElementVNode("div", null, [
                                                  _createVNode(_component_el_form_item, {
                                                    label: _ctx.type=='10'?'生产销售单位':'消费使用单位',
                                                    "label-width": "99px",
                                                    prop: "ProductionSaleCode"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductionSaleCode), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["label"])
                                                ]),
                                                _createElementVNode("div", _hoisted_69, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "ProductionSaleCompanyName",
                                                    style: {"margin-left":"-10px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductionSaleCompanyName), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_70, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_71,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "监管方式",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "SupervisionModeId",
                                                    style: {"margin-left":"-9px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.SupervisionMode!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(_ctx.detail.Data.SupervisionMode.FullName), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_74, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_75,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "征免性质",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_76, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "ExemptionNatureId",
                                                    style: {"margin-left":"-10px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.ExemptionNature!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_77, _toDisplayString(_ctx.detail.Data.ExemptionNature.Abbr) + "/" + _toDisplayString(_ctx.detail.Data.ExemptionNature.Code), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              (_ctx.type=='10')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_78, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_79,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "许可证号",
                                                        "label-width": "70px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_80, [
                                                      _createVNode(_component_el_form_item, {
                                                        "label-width": "0px",
                                                        prop: "PermitNumber"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.PermitNumber), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.type=='20')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_81, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_82,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "许可证号",
                                                        "label-width": "70px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_83, [
                                                      _createVNode(_component_el_form_item, {
                                                        "label-width": "3px",
                                                        prop: "PermitNumber"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.PermitNumber), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (_ctx.type=='20')
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_84, [
                                                    _createElementVNode("div", null, [
                                                      _hoisted_85,
                                                      _createVNode(_component_el_form_item, {
                                                        label: "启运港",
                                                        "label-width": "55px",
                                                        style: {"margin-top":"-34px"}
                                                      })
                                                    ]),
                                                    _createElementVNode("div", _hoisted_86, [
                                                      _createVNode(_component_el_form_item, { "label-width": "3px" }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.DeparturePort) + "  ", 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ])
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_87, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_88,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "合同协议号",
                                                    "label-width": "85px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_89, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "ContractNumber",
                                                    style: {"margin-left":"-9px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ContractNumber), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_90, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_91,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "贸易国（地区）",
                                                    "label-width": "110px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_92, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: "",
                                                    prop: "TradingCountryId"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.TradingCountry!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_93, _toDisplayString(_ctx.detail.Data.TradingCountry.NameZh), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_94, [
                                                (_ctx.type=='10')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                                      _createElementVNode("div", null, [
                                                        _hoisted_96,
                                                        _createVNode(_component_el_form_item, {
                                                          label: "运抵国（地区）",
                                                          "label-width": "110px",
                                                          style: {"margin-top":"-34px"}
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_97, [
                                                        _createVNode(_component_el_form_item, {
                                                          "label-width": "0px",
                                                          label: " ",
                                                          prop: "ArrivalCountryId",
                                                          style: {"margin-left":"-10px"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            (_ctx.detail.Data.ArrivalCountry!=undefined)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_98, _toDisplayString(_ctx.detail.Data.ArrivalCountry.NameZh), 1))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]))
                                                  : (_ctx.type=='20')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                                                        _createElementVNode("div", null, [
                                                          _hoisted_100,
                                                          _createVNode(_component_el_form_item, {
                                                            label: "启运国（地区）",
                                                            "label-width": "112px",
                                                            style: {"margin-top":"-34px"}
                                                          })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_101, [
                                                          _createVNode(_component_el_form_item, {
                                                            "label-width": "25px",
                                                            label: " ",
                                                            prop: "DepartureCountryId",
                                                            style: {"margin-left":"-22px"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (_ctx.detail.Data.DepartureCountry!=undefined)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(_ctx.detail.Data.DepartureCountry.FullName), 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_103, [
                                                (_ctx.type=='10')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                      _createElementVNode("div", null, [
                                                        _hoisted_105,
                                                        _createVNode(_component_el_form_item, {
                                                          label: "指运港",
                                                          "label-width": "55px",
                                                          style: {"margin-top":"-34px"}
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_106, [
                                                        _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.detail.Data.PortOfDestination), 1)
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]))
                                                  : (_ctx.type=='20')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                        _createElementVNode("div", null, [
                                                          _hoisted_108,
                                                          _createVNode(_component_el_form_item, {
                                                            label: "经停港",
                                                            "label-width": "55px",
                                                            style: {"margin-top":"-34px"}
                                                          })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_109, [
                                                          _createVNode(_component_el_form_item, {
                                                            "label-width": "0px",
                                                            label: " ",
                                                            prop: "StopPortId",
                                                            style: {"margin-left":"-10px"}
                                                          }, {
                                                            default: _withCtx(() => [
                                                              (_ctx.detail.Data.StopPort!=undefined)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_110, _toDisplayString(_ctx.detail.Data.StopPort.NameZh), 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ]),
                                              _createElementVNode("td", _hoisted_111, [
                                                (_ctx.type=='10')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                                      _createElementVNode("div", null, [
                                                        _hoisted_113,
                                                        _createVNode(_component_el_form_item, {
                                                          label: "离境口岸",
                                                          "label-width": "70px",
                                                          style: {"margin-top":"-34px"}
                                                        })
                                                      ]),
                                                      _createElementVNode("div", _hoisted_114, [
                                                        _createVNode(_component_el_form_item, { "label-width": "6px" })
                                                      ])
                                                    ]))
                                                  : (_ctx.type=='20')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                                        _createElementVNode("div", null, [
                                                          _hoisted_116,
                                                          _createVNode(_component_el_form_item, {
                                                            label: "入境口岸",
                                                            "label-width": "70px",
                                                            style: {"margin-top":"-34px"}
                                                          })
                                                        ]),
                                                        _createElementVNode("div", _hoisted_117, [
                                                          _createVNode(_component_el_form_item, { "label-width": "6px" }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(_ctx.detail.Data.EntryPort) + "  ", 1)
                                                            ]),
                                                            _: 1
                                                          })
                                                        ])
                                                      ]))
                                                    : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_118, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_119,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "包装种类",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_120, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "PackName",
                                                    style: {"margin-left":"-10px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_121, _toDisplayString(_ctx.detail.Data.PackName), 1),
                                                      _createElementVNode("div", _hoisted_122, [
                                                        _createVNode(_component_el_button, {
                                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onPackage())),
                                                          type: "info",
                                                          plain: "",
                                                          style: {"min-width":"80px","text-align":"center","margin-left":"10px","padding-left":"5px","padding-right":"5px"}
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("其他包装")
                                                          ]),
                                                          _: 1
                                                        })
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_123, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_124,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "件数",
                                                    "label-width": "40px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_125, [
                                                  _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductNumber) + "  ", 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_126, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_127,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "毛重（千克）",
                                                    "label-width": "98px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_128, [
                                                  _createVNode(_component_el_form_item, { "label-width": "3px" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductGrossWeight) + "  ", 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_129, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_130,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "净重（千克）",
                                                    "label-width": "98px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_131, [
                                                  _createVNode(_component_el_form_item, { "label-width": "3px" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ProductNetWeight) + "  ", 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_132, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_133,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "成交方式",
                                                    "label-width": "70px",
                                                    style: {"margin-top":"-34px"}
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_134, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "TransactionModeId",
                                                    style: {"margin-left":"-9px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (_ctx.detail.Data.TransactionMode!=undefined)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_135, _toDisplayString(_ctx.detail.Data.TransactionMode.FullName), 1))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_136, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_137,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "运费",
                                                    "label-width": "40px",
                                                    style: {"margin-top":"-34px","text-align":"right"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_138, [
                                                        _hoisted_139,
                                                        _createElementVNode("a", _hoisted_140, [
                                                          (_ctx.detail.Data.FreightCurrencySystem!=undefined)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_141, _toDisplayString(_ctx.detail.Data.FreightCurrencySystem.Code), 1))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_142, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "Freight"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_el_form_item, {
                                                        "label-width": "0px",
                                                        label: " ",
                                                        prop: "Premium",
                                                        style: {"margin-left":"-22px"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(_ctx.detail.Data.Freight), 1)
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_143, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_144,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "保费",
                                                    "label-width": "40px",
                                                    style: {"margin-top":"-34px","text-align":"right"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_145, [
                                                        _hoisted_146,
                                                        _createElementVNode("a", _hoisted_147, [
                                                          (_ctx.detail.Data.PremiumCurrencySystem!=undefined)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_148, _toDisplayString(_ctx.detail.Data.PremiumCurrencySystem.Code), 1))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_149, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "0px",
                                                    label: " ",
                                                    prop: "Premium",
                                                    style: {"margin-left":"-11px"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.Premium), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ]),
                                              _createElementVNode("td", _hoisted_150, [
                                                _createElementVNode("div", null, [
                                                  _hoisted_151,
                                                  _createVNode(_component_el_form_item, {
                                                    label: "杂费",
                                                    "label-width": "40px",
                                                    style: {"margin-top":"-34px","text-align":"right"}
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_152, [
                                                        _hoisted_153,
                                                        _createElementVNode("a", _hoisted_154, [
                                                          (_ctx.detail.Data.IncidentalCurrencySystem!=undefined)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_155, _toDisplayString(_ctx.detail.Data.IncidentalCurrencySystem.Code), 1))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _createElementVNode("div", _hoisted_156, [
                                                  _createVNode(_component_el_form_item, {
                                                    "label-width": "2px",
                                                    prop: "Incidental"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.Incidental), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_157, [
                                                _createVNode(_component_el_form_item, {
                                                  label: "随附单证及编号",
                                                  "label-width": "150px",
                                                  style: {"margin-top":"5px"}
                                                }),
                                                _createVNode(_component_el_form_item, {
                                                  label: "随附单证代码",
                                                  "label-width": "150px",
                                                  style: {"margin-top":"10px"}
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.detail.Data.AttachedCode), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_158, [
                                                  _createVNode(_component_el_form_item, {
                                                    label: "电子底账数据号码",
                                                    "label-width": "150px"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(_ctx.detail.Data.ElectronicAccountDataNumber), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_159, [
                                                _createVNode(_component_el_form_item, {
                                                  label: "标记唛码及备注",
                                                  "label-width": "150px"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", {
                                                      style: {"width":"100% !important","min-height":"95px"},
                                                      innerHTML: _ctx.detail.Data.CustomsShippingMark
                                                    }, null, 8, _hoisted_160)
                                                  ]),
                                                  _: 1
                                                }),
                                                _hoisted_161
                                              ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                              _createElementVNode("td", _hoisted_162, [
                                                _hoisted_163,
                                                (_ctx.detail.Data.OrderDepartureCustomsProducts==null || _ctx.detail.Data.OrderDepartureCustomsProducts==undefined || _ctx.detail.Data.OrderDepartureCustomsProducts.length<=0)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_164, _hoisted_166))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_167, [
                                                      _createElementVNode("table", _hoisted_168, [
                                                        _hoisted_169,
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.OrderDepartureCustomsProducts, (p, index) => {
                                                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                            _createElementVNode("td", _hoisted_170, [
                                                              _createElementVNode("div", _hoisted_171, [
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"width":"4%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(index + 1), 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"width":"9%","float":"left","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.RecordOrder) + " ", 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"width":"7%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.HsCode) + " ", 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"width":"15%","float":"left"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, [
                                                                  _createTextVNode(_toDisplayString(p.ProductNameZh) + "/" + _toDisplayString(p.ProductNameEn) + " ", 1),
                                                                  _hoisted_172,
                                                                  _createTextVNode(" " + _toDisplayString(p.SpecName) + "   ", 1)
                                                                ], 4),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"10%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    innerHTML: p.NewPrice
                                                                  }, null, 8, _hoisted_173),
                                                                  _createTextVNode("   ")
                                                                ], 4),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"8%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, [
                                                                  (p.UnitPrice!=null && p.UnitPrice!='')
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_174, [
                                                                        _createElementVNode("p", _hoisted_175, _toDisplayString(p.UnitPrice) + " ", 1),
                                                                        _createElementVNode("p", _hoisted_176, _toDisplayString(p.TotalPrice) + " ", 1),
                                                                        _createElementVNode("p", _hoisted_177, _toDisplayString(p.CurrencySystemName) + " ", 1)
                                                                      ]))
                                                                    : _createCommentVNode("", true),
                                                                  _createTextVNode("   ")
                                                                ], 4),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.OriginCountryName) + " ", 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.FinanCountryName) + " ", 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"12%","word-break":"break-all"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.DomesticGoodsPlaceName) + " ", 5),
                                                                _createElementVNode("div", {
                                                                  style: _normalizeStyle([{"float":"left","width":"6%"}, (p.IsTemporary==null || p.IsTemporary == true)?'color:red;':''])
                                                                }, _toDisplayString(p.ExemptingModeName) + " ", 5),
                                                                _createElementVNode("div", _hoisted_178, [
                                                                  _createElementVNode("a", {
                                                                    href: "javascript:;",
                                                                    onClick: ($event: any) => (_ctx.onProductDetail(p)),
                                                                    title: "查看"
                                                                  }, [
                                                                    _createVNode(_component_el_icon, {
                                                                      style: _normalizeStyle((p.IsTemporary==null || p.IsTemporary == true)?'color:red;':'')
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createVNode(_component_Document)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["style"])
                                                                  ], 8, _hoisted_179)
                                                                ]),
                                                                _hoisted_180
                                                              ]),
                                                              _createElementVNode("div", {
                                                                style: {"clear":"both","font-size":"13px","height":"24px","line-height":"24px","color":"#666","padding-top":"5px"},
                                                                innerHTML: '申报要素：' + p.DeclarationElement
                                                              }, null, 8, _hoisted_181)
                                                            ])
                                                          ]))
                                                        }), 128))
                                                      ])
                                                    ]))
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
        header: _withCtx(() => [
          _createElementVNode("div", {
            style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isAnnex = !_ctx.isAnnex))
          }, [
            _createElementVNode("div", _hoisted_182, [
              _createTextVNode("附件 "),
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_Paperclip)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_183, [
              (_ctx.isAnnex==false)
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowDownBold)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ArrowUpBold)
                    ]),
                    _: 1
                  }))
            ])
          ])
        ]),
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_184, [
            _createVNode(_component_el_row, {
              gutter: 24,
              class: "row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_185, [
                      _createElementVNode("tr", null, [
                        _hoisted_186,
                        _createElementVNode("td", {
                          style: {"font-size":"12px","cursor":"pointer","color":"#409eff"},
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onExport()))
                        }, " 预览 ")
                      ]),
                      (_ctx.detail.Data.OrderDepartureCustomsAnnexs!=null && _ctx.detail.Data.OrderDepartureCustomsAnnexs!=undefined && _ctx.detail.Data.OrderDepartureCustomsAnnexs.length>0)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_187, [
                            _createElementVNode("td", _hoisted_188, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.OrderDepartureCustomsAnnexs, (p, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  style: {"line-height":"24px"},
                                  key: index
                                }, [
                                  _hoisted_189,
                                  _createTextVNode(" 报关资料附件-" + _toDisplayString(index + 1), 1)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("td", _hoisted_190, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.Data.OrderDepartureCustomsAnnexs, (p, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  style: {"line-height":"24px"},
                                  key: index
                                }, [
                                  _createElementVNode("a", {
                                    style: {"color":"#409eff","text-decoration":"none"},
                                    target: "_blank",
                                    href: p.Url
                                  }, "预览", 8, _hoisted_191)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ], 512), [
            [_vShow, _ctx.isAnnex==false]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.packRuleForm.Visible,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.packRuleForm.Visible) = $event)),
        "show-close": false,
        top: "10px",
        style: {"width":"50%"},
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_192,
          _createElementVNode("div", _hoisted_193, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: _ctx.packages,
            ref: "packageTable",
            stripe: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "选择",
                prop: "isSelected",
                width: "80"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.isSelected == false)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_194))
                    : (_openBlock(), _createElementBlock("div", _hoisted_195, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Check)
                          ]),
                          _: 1
                        })
                      ]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                type: "index",
                label: "序号",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "Data",
                label: "包装种类代码",
                width: "200"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.Data.Code), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "Label",
                label: "包装种类名称"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.Label), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_196, [
            _createVNode(_component_miezz_button_bar, {
              modelValue: _ctx.packageBottomButtons,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.packageBottomButtons) = $event)),
              isBackground: true,
              onHandleClick: _ctx.handleClickPackage
            }, null, 8, ["modelValue", "onHandleClick"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_miezz_button_bar, {
        modelValue: _ctx.bottomButtons,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bottomButtons) = $event)),
        onHandleClick: _ctx.handleClick
      }, null, 8, ["modelValue", "onHandleClick"])
    ])), [
      [
        _directive_loading,
        _ctx.isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_miezz_customs_product_detail, { ref: "CustomsProductDetail" }, null, 512)
  ], 64))
}